export default __webpack_public_path__ + "static/media/slide_4.a3b203ec.jpg";